export default __webpack_public_path__ + "static/media/garden.ef63e456.jpg";